import { graphql } from "~/gql";

export const CREATE_TECHNOLOGY_UNIT = graphql(/* GraphQL */ `
  mutation CreateTechnologyUnit($data: TechnologyUnitCreateInput!) {
    createTechnologyUnit(data: $data) {
      ...TechnologyUnitParts
    }
  }
`);
